<template>
  <div class="common-layout">
    <el-container class="container">
      <el-container>
        <el-header class="header">
          <div class="title">ZS-TEK 智慧鞋机管控平台</div>
          <div class="exit">
            <el-icon
              :size="25"
              style="cursor: pointer; vertical-align: middle;"
              @click="Exit"
            >
              <CloseBold />
            </el-icon>
          </div>
        </el-header>
        <el-container>
          <el-aside
            width="200px"
            class="aside"
          >
            <el-scrollbar>
              <el-menu
                unique-opened
                :default-openeds="[props.openeds]"
                :default-active="props.menuIndex"
                router
                background-color="transparent"
                v-if="props.menuIndex"
              >
                <el-sub-menu index="equipment">
                  <template #title>
                    <el-icon style="vertical-align: middle">
                      <Setting />
                    </el-icon>设备
                  </template>
                  <el-menu-item index="/equipmentList">设备列表</el-menu-item>
                  <el-menu-item index="/equipmentAdd">新增/编辑</el-menu-item>
                </el-sub-menu>
                <el-sub-menu index="attribution">
                  <template #title>
                    <el-icon style="vertical-align: middle">
                      <OfficeBuilding />
                    </el-icon>归属方
                  </template>
                  <el-menu-item index="/company">公司列表</el-menu-item>
                  <el-menu-item index="/factory">厂区列表</el-menu-item>
                  <el-menu-item index="/workshop">车间列表</el-menu-item>
                </el-sub-menu>
                <el-sub-menu index="instructions">
                  <template #title>
                    <el-icon style="vertical-align: middle">
                      <Document />
                    </el-icon>说明书
                  </template>
                  <el-menu-item index="/instructions/instructionsList">说明书列表</el-menu-item>
                  <el-menu-item index="/instructions/createQR">新增说明书</el-menu-item>
                </el-sub-menu>
              </el-menu>
            </el-scrollbar>
          </el-aside>
          <el-main class="main">
            <slot></slot>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import router from '@/router';
import { ElMessageBox, ElNotification } from 'element-plus';
import { WarningFilled } from '@element-plus/icons-vue';
import { h, markRaw } from 'vue';

export default {
  name: 'DefaultLayout',
  props: {
    menuIndex: String,
    openeds: String
  },
  setup (props) {
    // 可以打印查看一下props传过来的属性以及属性的值
    // console.log(props);
    const Exit = () => {
      ElMessageBox.confirm(
        '<strong style="color: #F56C6C;">退出登录?</strong>',
        {
          type: 'error',
          showCancelButton: false,
          autofocus: false,
          confirmButtonClass: 'defaultLayout-exit-confirmButtonClass',
          dangerouslyUseHTMLString: true,
          icon: markRaw(WarningFilled),
        }
      )
        .then(() => {
          router.push('/login');
          ElNotification({
            message: h('i', { style: 'color: teal' }, '退出成功'),
          })
        })
        .catch(() => {

        })
    }

    return {
      props,
      Exit
    }
  }
}
</script>

<style>
.defaultLayout-exit-confirmButtonClass {
  background: #F56C6C !important;
  border: 0;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.common-layout {
  height: 100%;
}

.container {
  height: 100%;
}

.header {
  background-color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}


.exit {
  color: #fff;
}

.title {
  letter-spacing: 3px;
  line-height: 60px;
  font-family: 'ALiMM';
  font-size: 20px;
  color: #fff;
}

.aside {
  height: calc(100vh - 60px);
  background: #E0E0E0;
}

.el-menu {
  border: 0;
}

.main {
  height: calc(100vh - 60px);
  overflow: auto;
  overflow-x: hidden;
}

.el-main {
  padding: 0;
}

@font-face {
  font-family: ALiMM;
  /* 定义字体名称 */
  src: url('../../assets/AlimamaFangYuanTiVF-Thin.ttf');
  /* 指定字体文件的路径 */
}
</style>
